import i18n from "./index";

/**
 * Unity element-név → megjelenítési HU név (kosár + checkout Smarty template).
 * Display-only: csak a Unity `Order[].Name`-re fut, közvetlenül a kosárba helyezés
 * előtt; a `LongName` és minden más mező érintetlen marad.
 *
 * A szóbontás domain-logika (path / sorszám / modifier-prefix), a leaf-fordítás t().
 */
const lcFirst = (s: string): string => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);

// Modifier-prefixek (orientation + dimension). Leghosszabb előre — és a
// "rest must be a known part" feltétel zárja ki a téves egyezést (pl. "Topology").
const MODIFIERS = ["Top", "Bottom", "Left", "Right", "Front", "Back", "Horizontal", "Vertical", "Depth"]
    .sort((a, b) => b.length - a.length);

const part = (key: string): boolean => i18n.exists(`elements:part.${key}`);

const translateToken = (token: string): string => {
    // "Shelf#1" → base + sorszám
    const ordinal = token.match(/^(.+?)#(\d+)$/);
    if (ordinal) return `${translateToken(ordinal[1])} ${ordinal[2]}`;

    if (part(token)) return i18n.t(`elements:part.${token}`);

    // Modifier-prefix + base, az elválasztó szóközt is tűrve ("Horizontal Divider")
    for (const mod of MODIFIERS) {
        if (!token.startsWith(mod) || token.length === mod.length) continue;
        const rest = token.slice(mod.length).trimStart();
        if (rest && part(rest)) {
            return i18n.t("elements:pattern", {
                mod: i18n.t(`elements:mod.${mod}`),
                base: lcFirst(i18n.t(`elements:part.${rest}`)),
            });
        }
    }

    // Ismeretlen → változatlan
    return token;
};

/**
 * @example translateElementName("Shelf#1.Board")    // "Polc 1"
 * @example translateElementName("LeftDrilling")     // "Bal fúrás"
 * @example translateElementName("Vertical Divider") // "Függőleges elválasztó"
 */
export const translateElementName = (raw: string): string =>
    raw ? raw.replace(/\.Board$/, "").split(".").map(translateToken).join(" ") : raw;